import { render } from "./AdditionalExhibitorsManager.vue?vue&type=template&id=43538e7c&scoped=true"
import script from "./AdditionalExhibitorsManager.vue?vue&type=script&lang=js"
export * from "./AdditionalExhibitorsManager.vue?vue&type=script&lang=js"

import "./AdditionalExhibitorsManager.vue?vue&type=style&index=0&id=43538e7c&scoped=true&lang=css"

import exportComponent from "/Users/diekstra/PhpstormProjects/rbs-vlb-reservations/rvr-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43538e7c"]])

export default __exports__